import zod from 'zod';

export const RecognitionCameraAvailableEvents = zod.enum([
  'FACE_DETECT',
  'FACE_RECOGNITION',
]);

export const RecognitionCameraConfigEditionFormSchema = zod.object({
  telegramIds: zod.array(zod.string()).optional(),
  whatsAppNumbers: zod.array(zod.string()).optional(),
  contextCameraId: zod.number().nullish(),
  emailAddresses: zod.array(zod.string().max(254).email()).optional(),
  smtpIntegrationId: zod.number().optional().nullable(),
  functionType: zod.enum(['EXIT', 'ENTRY', 'COMMON','TAG']).default('COMMON'),
  isNotifyLogEvent: zod.boolean(),
  hasDoorConfirmation: zod.boolean(),
});
